import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { switchMap} from "rxjs/operators";
import * as JSZip from 'jszip';
import FileSaver  from 'file-saver';
import { ResponseServiceAction } from "app/interfaces/response-service.interface";
import * as uuid from 'uuid';

declare global {
    interface Navigator {
      msSaveOrOpenBlob: (blobOrBase64: Blob) => boolean
    }
}

export interface DownloadImage {
    url: string;
    imageName: string;
}

@Injectable({
  providedIn: "root"
})
export class ImageService {
  constructor(private httpClient: HttpClient) {}

  //to get Random image
  getData(url: string): Observable<string> {
    return this.httpClient
      .get(url, { responseType: "blob" })
      .pipe(switchMap(response => this.readFile(response)));
  }

  private readFile(blob: Blob): Observable<string> {
    return Observable.create(obs => {
      const reader = new FileReader();

      reader.onerror = err => obs.error(err);
      reader.onabort = err => obs.error(err);
      reader.onload = () => obs.next(reader.result);
      reader.onloadend = () => obs.complete();

      return reader.readAsDataURL(blob);
    });
  }

  // download Image
  download(img: string,fileName?: string) {
    const imgUrl = img;
    const imgName = fileName || uuid();
    this.httpClient
      .get(imgUrl, { responseType: "blob" as "json" })
      .subscribe((res: any) => {
        var type = res.type.split('/')[1];
        if (type == 'octet-stream') {
          type = 'png';
        }
        const file = new Blob([res], { type: `.${type}`});

        // IE
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
          return;
        }

        const blob = window.URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = blob;
        link.download = `${imgName}.${type}`;

        // Version link.click() to work at firefox
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window
          })
        );

        setTimeout(() => {
          // firefox
          window.URL.revokeObjectURL(blob);
          link.remove();
        }, 100);
      });
  }

  //downloadAll
  async downloadAlldownload(images: DownloadImage[],name: string) {
    const zip = new JSZip();
    for (let i = 0; i < images.length; i++) {
      const imgUrl = images[i].url;
      const imgName = images[i].imageName;
      await this.httpClient
        .get(imgUrl, { responseType: "blob" as "json" }).toPromise()
        .then((res: any) => {
          const file = new Blob([res], { type: res.type });
          var type = res.type.split('/')[1];
          if (type == 'octet-stream') {
            type = 'png';
          }
          zip.file(`${imgName}.${type}`,file,{base64: true});
        });
    }

    zip.generateAsync({ type: "blob" })
      .then(function (content) {
          // IE
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(content);
            return;
          }

          const blob = window.URL.createObjectURL(content);
          const link = document.createElement("a");
          link.href = blob;
          link.download = `${name}.zip`;

          // Version link.click() to work at firefox
          link.dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window
            })
          );

          setTimeout(() => {
            // firefox
            window.URL.revokeObjectURL(blob);
            link.remove();
          }, 100);
      });
  }
}
